import _ from 'lodash';
import { getPartnerMessageWithSomePureRules } from '@/views/config/partner-refer/helper/message';
import { getPartnerImageFileInfo } from '@/views/config/partner-refer/helper/utils';

export default {
  computed: {
    partnerRefer() {
      return {};
    },
    successContent() {
      const defaultMsg = _.get(this.partnerRefer, ['messageMap', 'successMsg', 0, 'messageBody']);
      const messageList = _.get(this.partnerRefer, ['messageMap', 'successMsg'], []);
      return getPartnerMessageWithSomePureRules(messageList, defaultMsg);
    },
    newSuccessMsg() {
      const imageFileInfo = getPartnerImageFileInfo(this.partnerRefer);

      return _.chain(this.successContent)
        .replace(`\${successLogoIcon}`, imageFileInfo.planCardLogo)
        .value();
    },
    successMsgForPartnership() {
      return this.newSuccessVersion ? this.newSuccessMsg : this.successContent;
    },
    newSuccessVersion() {
      return _.includes(this.successContent, 'newSuccessVersion');
    },
  },
};
